/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Assign_User_AriaInputs */



/**
* | output |
* | --- |
* | "Assign to User" |
*
* @param {Explorer_Info_Assign_User_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_assign_user_aria = /** @type {((inputs?: Explorer_Info_Assign_User_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Assign_User_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Assigner a un utilisateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dem Benutzer zuweisen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegna all'utente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назначить пользователю")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asignar a usuario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分配给用户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザーに割り当てる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता को असाइन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atribuir ao usuário")
	return /** @type {LocalizedString} */ ("Assign to User")
});